module.exports = __webpack_public_path__ + "img/without.d17152db.svg";